// Status que o backend devolve para indicar a situação da estação de trabalho
// no login/cadastro (enum WorkstationAuthorizationRequestStatus):
//   - Pending  → cadastro enviado, aguardando aprovação do supervisor
//   - Approved → estação de trabalho liberada; tokens vêm preenchidos
//   - Rejected → sem estação de trabalho aprovada/pendente, assinatura inválida
//                ou aprovação expirada (90d) → a UI oferece (re)cadastro
//   - NotFound → consulta de status não encontrou registro para o par
//                (email, thumbprint): email desconhecido, thumbprint sem
//                correspondência, ou aprovação obsoleta (90d) já apagada.
//                Só existe na consulta anônima de status (poll), não no cadastro.
//
// O backend serializa o enum como inteiro, então o campo chega como string
// "1"/"2"/"3"/"4". `normalizeWorkstationAuthStatus` aceita tanto o nome quanto o
// número e devolve sempre um dos valores acima.
export const WORKSTATION_AUTH_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  NOT_FOUND: 'NotFound',
};

const NUMERIC_TO_NAME = {
  1: WORKSTATION_AUTH_STATUS.PENDING,
  2: WORKSTATION_AUTH_STATUS.APPROVED,
  3: WORKSTATION_AUTH_STATUS.REJECTED,
  4: WORKSTATION_AUTH_STATUS.NOT_FOUND,
};

const VALID_NAMES = new Set(Object.values(WORKSTATION_AUTH_STATUS));

export const normalizeWorkstationAuthStatus = raw => {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === 'number') return NUMERIC_TO_NAME[raw] || null;
  if (typeof raw === 'string') {
    if (VALID_NAMES.has(raw)) return raw;
    const asNumber = Number(raw);
    if (!Number.isNaN(asNumber) && NUMERIC_TO_NAME[asNumber]) {
      return NUMERIC_TO_NAME[asNumber];
    }
  }
  return null;
};
